import { render, staticRenderFns } from "./TaskBoard.vue?vue&type=template&id=cabd0314&scoped=true&"
import script from "./TaskBoard.vue?vue&type=script&lang=js&"
export * from "./TaskBoard.vue?vue&type=script&lang=js&"
import style0 from "./TaskBoard.vue?vue&type=style&index=0&id=cabd0314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabd0314",
  null
  
)

export default component.exports